import gql from 'graphql-tag';
import type {RouteLocationNormalized} from 'vue-router';
import type {Page} from '../index';
import {useSofieConfig} from '../composables/config';

export const pageSymbol = Symbol('page');

export default defineNuxtRouteMiddleware(async function (route: RouteLocationNormalized) {
  const pages = useState<Record<string, Page>>('pages', () => ({}));
  const slug = route.path.replace(/^\//, '') || 'home';
  const page: Page = pages.value[slug] ??= await fetchPage(slug);

  useServerSeoMeta({
    description: page.seo?.meta_description || undefined,
    ogDescription: page.seo?.meta_description || undefined,
    ogImage: page.active_image?.url || undefined,
    ogTitle: page.seo?.meta_title || undefined,
    robots: `${page.seo?.meta_follow ? 'follow' : 'nofollow'} ${page.seo?.meta_index ? 'index' : 'noindex'}`,
  });

  useSeoMeta({
    title: page.title,
  });

  route.meta[pageSymbol] = page;
});

async function fetchPage(slug: string) {
  const nuxt = useNuxtApp();

  // Strip locale prefix from slug, it is already passed to Sofie in the X-Locale header
  if (nuxt.$i18n) {
    const locale = (nuxt.$i18n as {locale: Ref<string>}).locale.value;

    if (slug === locale || slug.startsWith(locale + '/')) {
      slug = slug.slice(locale.length + 1);
    }
  }

  const config = useSofieConfig();
  const {client} = useApolloClient();

  const {data} = await client.query<{
    page: Page
  }>({
    query: gql(config.queries.page),
    variables: {segments: slug},
  });

  if (!data?.page) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Pagina niet gevonden',
    });
  }

  return data.page;
}
